import axiosInstance from "@API/axios";
import { useDispatch } from "react-redux";
import { setSnackbar } from "@Redux/snackBarSlice";

const useGetItem = () => {
  const dispatch = useDispatch();
  const getItem = (url, id) => {
    return axiosInstance
      .get(`${url}/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (error.response.status === 404) {
          dispatch(
            setSnackbar({
              open: true,
              message: "The item is not found",
              error: true,
            })
          );
        } else {
          dispatch(
            setSnackbar({
              open: true,
              message:
                typeof error.response?.data === "object"
                  ? error.response?.data.details
                  : error.response?.data,
              error: true,
            })
          );
        }
      });
  };
  return getItem;
};

export default useGetItem;
